// ============================================================================
// HEAP SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'heap-sort',
  name: 'Heap Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n log n)',
    space: 'O(1)'
  },
  description: 'A comparison-based sorting algorithm that uses a binary heap data structure. It divides the input into a sorted and an unsorted region and iteratively shrinks the unsorted region by extracting the largest element and moving it to the sorted region.'
};
